/**
 * Product Card V2 Renderer
 * Renders product cards client-side from Algolia hit data.
 * Mirrors snippets/card-product-v2.liquid exactly.
 *
 * Usage:
 *   const html = window.renderProductCardV2(hit, index);
 *   container.innerHTML += html;
 *   window.initFlashSaleCountdowns(container);
 */
(function () {
  'use strict';

  // ── SVG Icons (copied verbatim from card-product-v2.liquid & usp-tag.liquid) ──

  const SVG_LOCATION_PIN = function (id) {
    return '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><g clip-path="url(#cp-loc-' + id + ')"><path d="M10 10.0001C10.5156 10.0001 10.957 9.82059 11.3242 9.46156C11.6914 9.10253 11.875 8.67093 11.875 8.16677C11.875 7.6626 11.6914 7.231 11.3242 6.87198C10.957 6.51295 10.5156 6.33343 10 6.33343C9.48438 6.33343 9.04297 6.51295 8.67578 6.87198C8.30859 7.231 8.125 7.6626 8.125 8.16677C8.125 8.67093 8.30859 9.10253 8.67578 9.46156C9.04297 9.82059 9.48438 10.0001 10 10.0001ZM10 16.7376C11.9062 15.0265 13.3203 13.472 14.2422 12.0741C15.1641 10.6761 15.625 9.43482 15.625 8.3501C15.625 6.68482 15.082 5.32128 13.9961 4.25948C12.9102 3.19767 11.5781 2.66677 10 2.66677C8.42188 2.66677 7.08984 3.19767 6.00391 4.25948C4.91797 5.32128 4.375 6.68482 4.375 8.3501C4.375 9.43482 4.83594 10.6761 5.75781 12.0741C6.67969 13.472 8.09375 15.0265 10 16.7376ZM10 19.1668C7.48438 17.0737 5.60547 15.1296 4.36328 13.3345C3.12109 11.5393 2.5 9.87788 2.5 8.3501C2.5 6.05843 3.25391 4.23274 4.76172 2.87302C6.26953 1.5133 8.01562 0.833435 10 0.833435C11.9844 0.833435 13.7305 1.5133 15.2383 2.87302C16.7461 4.23274 17.5 6.05843 17.5 8.3501C17.5 9.87788 16.8789 11.5393 15.6367 13.3345C14.3945 15.1296 12.5156 17.0737 10 19.1668Z" fill="#585468"/></g><defs><clipPath id="cp-loc-' + id + '"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>';
  };

  var SVG_STAR = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.6775 13.6501L3.815 8.7326L0 5.4251L5.04 4.9876L7 0.350098L8.96 4.9876L14 5.4251L10.185 8.7326L11.3225 13.6501L7 11.0426L2.6775 13.6501Z" fill="#FDB022"/></svg>';

  var SVG_PERSON_SINGLE = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.99219 7.82956C11.6932 7.82956 13.0721 6.45063 13.0721 4.74963C13.0721 3.04864 11.6932 1.66971 9.99219 1.66971C8.29119 1.66971 6.91226 3.04864 6.91226 4.74963C6.91226 6.45063 8.29119 7.82956 9.99219 7.82956ZM9.99219 9.49964C12.6155 9.49964 14.7422 7.37299 14.7422 4.74963C14.7422 2.12628 12.6155 -0.000366211 9.99219 -0.000366211C7.36884 -0.000366211 5.24219 2.12628 5.24219 4.74963C5.24219 7.37299 7.36884 9.49964 9.99219 9.49964Z" fill="#585468"/><path fill-rule="evenodd" clip-rule="evenodd" d="M4.91312 18.5896C6.31312 19.5296 8.15312 19.9996 9.99312 19.9996C11.8331 19.9996 13.6731 19.5296 15.0731 18.5896C16.3331 17.7396 17.0331 16.5996 17.0331 15.3596C17.0231 14.1296 16.3331 12.9896 15.0731 12.1496C12.2831 10.2896 7.73312 10.2896 4.92312 12.1496C3.65313 12.9996 2.95312 14.1496 2.95312 15.3796C2.95312 16.6096 3.65313 17.7496 4.91312 18.5896ZM5.8485 13.5399C4.91866 14.1635 4.6232 14.8437 4.6232 15.3796C4.6232 15.9141 4.91703 16.5851 5.83952 17.2001L5.84409 17.2031C6.91303 17.9208 8.4105 18.3296 9.99312 18.3296C11.575 18.3296 13.0719 17.9212 14.1407 17.2041C15.0635 16.581 15.3606 15.9112 15.363 15.3664C15.3561 14.8151 15.056 14.1454 14.1467 13.5392C13.0826 12.8298 11.5887 12.4247 10.0056 12.4247C8.42482 12.4247 6.92484 12.8288 5.8485 13.5399Z" fill="#585468"/></svg>';

  var SVG_PERSON_MULTI = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.28278 8.01123C8.84164 8.01123 10.1053 6.74752 10.1053 5.18866C10.1053 3.6298 8.84164 2.3661 7.28278 2.3661C5.72392 2.3661 4.46021 3.6298 4.46021 5.18866C4.46021 6.74752 5.72392 8.01123 7.28278 8.01123ZM7.28278 9.54175C9.68692 9.54175 11.6359 7.59281 11.6359 5.18866C11.6359 2.78452 9.68692 0.835571 7.28278 0.835571C4.87863 0.835571 2.92969 2.78452 2.92969 5.18866C2.92969 7.59281 4.87863 9.54175 7.28278 9.54175Z" fill="#585468"/><path fill-rule="evenodd" clip-rule="evenodd" d="M2.63216 17.8721C3.91518 18.7335 5.60143 19.1643 7.28767 19.1643C8.97392 19.1643 10.6602 18.7335 11.9432 17.8721C13.0979 17.0931 13.7394 16.0484 13.7394 14.912C13.7302 13.7848 13.0979 12.74 11.9432 11.9702C9.38632 10.2656 5.21652 10.2656 2.64132 11.9702C1.47745 12.7492 0.835938 13.8031 0.835938 14.9303C0.835938 16.0575 1.47745 17.1023 2.63216 17.8721ZM3.48937 13.2443C2.63724 13.8158 2.36646 14.4391 2.36646 14.9303C2.36646 15.4201 2.63574 16.035 3.48114 16.5986C4.46495 17.2592 5.83729 17.6337 7.28767 17.6337C8.7374 17.6337 10.1092 17.2595 11.0887 16.6023C11.9344 16.0313 12.2067 15.4174 12.2089 14.9181C12.2026 14.4129 11.9275 13.7992 11.0942 13.2437C10.119 12.5936 8.74989 12.2223 7.29913 12.2223C5.85042 12.2223 4.47577 12.5926 3.48937 13.2443Z" fill="#585468"/><path d="M17.3574 5.72943C17.504 7.50732 16.2394 9.06527 14.489 9.27605H14.4431C14.3882 9.27605 14.3332 9.27605 14.2873 9.29438C13.3984 9.3402 12.5828 9.05611 11.9688 8.53374C12.9127 7.69061 13.4534 6.42593 13.3434 5.05126C13.2793 4.30895 13.0227 3.63078 12.6378 3.05343C12.986 2.8793 13.3892 2.76933 13.8016 2.73267C15.5979 2.57688 17.2016 3.91488 17.3574 5.72943Z" fill="#585468"/><path d="M19.1831 14.2064C19.1098 15.0953 18.5416 15.8651 17.5885 16.3875C16.672 16.8915 15.5173 17.1298 14.3718 17.1023C15.0316 16.5066 15.4165 15.7643 15.4898 14.9762C15.5815 13.8398 15.0408 12.7492 13.9594 11.8786C13.3454 11.3929 12.6305 11.008 11.8516 10.7239C13.8769 10.1374 16.4246 10.5314 17.9917 11.7961C18.8348 12.4743 19.2656 13.3266 19.1831 14.2064Z" fill="#585468"/></svg>';

  var SVG_LAYERS = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10.0026 11.6665L0.835938 6.6665L10.0026 1.6665L19.1693 6.6665L10.0026 11.6665ZM10.0026 14.9998L1.3151 10.2707L3.0651 9.31234L10.0026 13.104L16.9401 9.31234L18.6901 10.2707L10.0026 14.9998ZM10.0026 18.3332L1.3151 13.604L3.0651 12.6457L10.0026 16.4373L16.9401 12.6457L18.6901 13.604L10.0026 18.3332ZM10.0026 9.77067L15.6901 6.6665L10.0026 3.56234L4.3151 6.6665L10.0026 9.77067Z" fill="currentColor"/></svg>';


  var SVG_BED = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M0.835938 16.6668V10.9525C0.835938 10.5239 0.919965 10.135 1.08802 9.78582C1.25608 9.43661 1.4776 9.12709 1.7526 8.85724V6.19058C1.7526 5.39693 2.01997 4.72232 2.55469 4.16677C3.08941 3.61121 3.73872 3.33344 4.5026 3.33344H8.16927C8.52066 3.33344 8.84913 3.4009 9.15469 3.53582C9.46024 3.67074 9.74288 3.85724 10.0026 4.09534C10.2623 3.85724 10.545 3.67074 10.8505 3.53582C11.1561 3.4009 11.4845 3.33344 11.8359 3.33344H15.5026C16.2665 3.33344 16.9158 3.61121 17.4505 4.16677C17.9852 4.72232 18.2526 5.39693 18.2526 6.19058V8.85724C18.5276 9.12709 18.7491 9.43661 18.9172 9.78582C19.0852 10.135 19.1693 10.5239 19.1693 10.9525V16.6668H17.3359V14.762H2.66927V16.6668H0.835938ZM10.9193 8.09534H16.4193V6.19058C16.4193 5.92074 16.3314 5.69455 16.1557 5.51201C15.98 5.32947 15.7623 5.2382 15.5026 5.2382H11.8359C11.5762 5.2382 11.3585 5.32947 11.1828 5.51201C11.0071 5.69455 10.9193 5.92074 10.9193 6.19058V8.09534ZM3.58594 8.09534H9.08594V6.19058C9.08594 5.92074 8.99809 5.69455 8.8224 5.51201C8.6467 5.32947 8.42899 5.2382 8.16927 5.2382H4.5026C4.24288 5.2382 4.02517 5.32947 3.84948 5.51201C3.67378 5.69455 3.58594 5.92074 3.58594 6.19058V8.09534ZM2.66927 12.8572H17.3359V10.9525C17.3359 10.6826 17.2481 10.4565 17.0724 10.2739C16.8967 10.0914 16.679 10.0001 16.4193 10.0001H3.58594C3.32622 10.0001 3.10851 10.0914 2.93281 10.2739C2.75712 10.4565 2.66927 10.6826 2.66927 10.9525V12.8572Z" fill="currentColor"/></svg>';

  var SVG_BUILDING = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none"><path d="M16.4365 0.666626C16.7618 0.666626 17.0463 0.756932 17.2188 1.0592C17.4945 1.54158 17.204 2.12877 16.6514 2.20569C16.5755 2.21615 16.4986 2.21836 16.4189 2.22131C16.381 2.22272 16.3423 2.22487 16.3027 2.22717V15.7487C16.3661 15.7612 16.4292 15.7712 16.4912 15.7809C16.6259 15.802 16.7565 15.8227 16.877 15.8688C17.1685 15.9805 17.3661 16.3324 17.3262 16.6041C17.2677 17.0017 17.0448 17.2482 16.6875 17.3073C16.6045 17.321 16.5201 17.3326 16.4365 17.3326C11.4751 17.3338 6.5136 17.3342 1.55273 17.3336C1.20899 17.3336 0.914115 17.2319 0.75 16.901C0.510824 16.4175 0.802036 15.8713 1.33789 15.7955C1.41314 15.7847 1.48973 15.7817 1.56934 15.7789C1.60762 15.7776 1.64667 15.7764 1.68652 15.774V2.21741C1.66124 2.21741 1.63583 2.21805 1.61035 2.21838C1.55908 2.21905 1.50733 2.21938 1.45605 2.21741C1.02465 2.19833 0.747287 1.95808 0.673828 1.5426C0.612369 1.19205 0.852927 0.787184 1.25684 0.698853C1.3529 0.67739 1.4533 0.667605 1.55176 0.667603C6.51333 0.66641 11.4749 0.666626 16.4365 0.666626ZM3.25977 15.7692H7.4248V12.8619C7.4248 12.4248 7.7787 12.0698 8.21582 12.069L9.7666 12.066C10.2049 12.0652 10.5615 12.4207 10.5615 12.859V15.775H14.7295L14.7285 2.23108H3.25977V15.7692Z" fill="currentColor"/></svg>';

  var SVG_HOME = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.0026 15.8333H7.5026V10.8333H12.5026V15.8333H15.0026V8.33333L10.0026 4.58333L5.0026 8.33333V15.8333ZM3.33594 17.5V7.5L10.0026 2.5L16.6693 7.5V17.5H10.8359V12.5H9.16927V17.5H3.33594Z" fill="#585468"/></svg>';

  // USP tag icons (from snippets/usp-tag.liquid)
  var SVG_USP_2P = '<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none"><circle cx="5.90659" cy="3.8325" r="3.31821" fill="white"/><path d="M9.45545 9.00197C7.50644 7.70263 4.32794 7.70263 2.36495 9.00197C1.47777 9.59576 0.98877 10.3991 0.98877 11.2584C0.98877 12.1176 1.47777 12.914 2.35797 13.5008C3.33597 14.1574 4.62134 14.4858 5.90671 14.4858C7.19208 14.4858 8.47745 14.1574 9.45545 13.5008C10.3357 12.907 10.8247 12.1106 10.8247 11.2444C10.8177 10.3851 10.3357 9.58877 9.45545 9.00197Z" fill="white"/><path d="M13.5842 4.24466C13.6959 5.59989 12.7319 6.78746 11.3976 6.94813C11.3906 6.94813 11.3906 6.94813 11.3837 6.94813H11.3627C11.3208 6.94813 11.2789 6.94813 11.2439 6.9621C10.5663 6.99703 9.94461 6.78047 9.47656 6.38229C10.1961 5.7396 10.6082 4.77557 10.5244 3.72771C10.4755 3.16187 10.2799 2.64493 9.98652 2.20483C10.252 2.0721 10.5593 1.98827 10.8737 1.96033C12.2429 1.84157 13.4654 2.86149 13.5842 4.24466Z" fill="white"/><path d="M14.9811 10.7064C14.9253 11.384 14.4921 11.9708 13.7656 12.369C13.0671 12.7532 12.1869 12.9349 11.3136 12.9139C11.8166 12.4598 12.11 11.894 12.1659 11.2932C12.2358 10.427 11.8236 9.5957 10.9993 8.93206C10.5312 8.56182 9.98636 8.26842 9.39258 8.05186C10.9364 7.60478 12.8784 7.90516 14.073 8.86919C14.7157 9.38613 15.044 10.0358 14.9811 10.7064Z" fill="white"/></svg>';

  var SVG_USP_HOTEL = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.2938 12.6955C13.2417 12.6873 13.1888 12.679 13.1355 12.6684V1.31072C13.1689 1.30877 13.2015 1.30756 13.2336 1.30637C13.3006 1.30389 13.365 1.30149 13.4287 1.29269C13.8929 1.22808 14.1366 0.735243 13.905 0.330058C13.7601 0.0761287 13.5215 0 13.2483 0C9.08066 0 4.91302 0 0.745391 0.00100169C0.66268 0.00100169 0.578465 0.00901524 0.497759 0.0270457C0.158393 0.101171 -0.0436221 0.441246 0.00800963 0.735744C0.0696669 1.08483 0.30226 1.28668 0.664685 1.3027C0.707851 1.30437 0.75124 1.30381 0.794405 1.30326C0.815904 1.30298 0.837347 1.3027 0.85868 1.3027V12.69C0.82516 12.6919 0.79238 12.6931 0.760185 12.6942C0.693197 12.6966 0.628743 12.6989 0.565432 12.708C0.115283 12.7716 -0.12884 13.2304 0.0721733 13.6366C0.210025 13.9145 0.457155 13.9997 0.745892 13.9997C4.91302 14.0002 9.08066 14.0002 13.2483 13.9992C13.3185 13.9992 13.3891 13.9897 13.4588 13.9781C13.7591 13.9286 13.9466 13.7212 13.9957 13.3871C14.0293 13.1587 13.8629 12.8627 13.6177 12.7691C13.5165 12.7303 13.407 12.7132 13.2938 12.6955ZM2.1797 1.31427V12.6855H5.67813V10.3702C5.67813 9.93309 6.03204 9.5785 6.46917 9.57767L7.5188 9.57567C7.95709 9.57484 8.31285 9.92992 8.31285 10.3682V12.6905H11.8143L11.8138 1.31427H6.99674H2.1797Z" fill="#FE4F28"/><path d="M4.36445 4.37088C4.23111 4.37088 4.09777 4.37388 3.96443 4.37038C3.68321 4.36286 3.5238 4.24116 3.50525 3.96569C3.4837 3.65116 3.48621 3.33262 3.50726 3.01809C3.5238 2.77468 3.63559 2.65848 3.87921 2.64195C4.20604 2.61992 4.53689 2.62092 4.86422 2.64346C5.10283 2.65998 5.21161 2.77268 5.22815 3.01258C5.24971 3.33162 5.25221 3.65417 5.22965 3.9727C5.21061 4.24266 5.0532 4.36186 4.7775 4.37038C4.64015 4.37488 4.5023 4.37088 4.36495 4.37138L4.36445 4.37088Z" fill="#FE4F28"/><path d="M6.9857 4.36536C6.83181 4.36536 6.67591 4.37938 6.52402 4.36235C6.27339 4.33431 6.15258 4.22512 6.13553 3.97019C6.11448 3.65566 6.11548 3.33712 6.13553 3.02259C6.15157 2.77517 6.26687 2.65747 6.51651 2.63994C6.83532 2.6179 7.15814 2.6179 7.47696 2.63994C7.72709 2.65697 7.84289 2.77417 7.85893 3.02109C7.87948 3.33612 7.88149 3.65416 7.85993 3.96869C7.84088 4.23965 7.68549 4.36035 7.41079 4.37037C7.26943 4.37538 7.12757 4.37137 6.9857 4.37137C6.9857 4.36937 6.9857 4.36786 6.9857 4.36586V4.36536Z" fill="#FE4F28"/><path d="M10.4889 3.49941C10.4889 3.66168 10.5049 3.82546 10.4854 3.98523C10.4548 4.23014 10.3521 4.34233 10.1084 4.35836C9.78912 4.37939 9.46679 4.3799 9.14748 4.35936C8.90035 4.34383 8.78305 4.22764 8.7655 3.97772C8.74345 3.65918 8.74395 3.33663 8.7645 3.01759C8.78004 2.77418 8.89233 2.65848 9.13645 2.64146C9.45927 2.61892 9.78661 2.61691 10.1089 2.64045C10.3731 2.65999 10.4884 2.81575 10.4974 3.08671C10.5019 3.22394 10.4984 3.36167 10.4984 3.49891C10.4954 3.49891 10.4919 3.49891 10.4889 3.49891V3.49941Z" fill="#FE4F28"/><path d="M5.24126 6.12986C5.24126 6.26309 5.24477 6.39631 5.24076 6.52954C5.23223 6.80751 5.11293 6.96677 4.84675 6.98531C4.52794 7.00734 4.20511 7.00584 3.8858 6.98481C3.64218 6.96878 3.52739 6.85659 3.51034 6.61218C3.48778 6.28963 3.48778 5.96308 3.50834 5.64003C3.52438 5.39712 3.63717 5.28443 3.88379 5.2669C4.20261 5.24436 4.52543 5.24236 4.84424 5.2649C5.11393 5.28443 5.23223 5.4417 5.24076 5.71766C5.24477 5.8549 5.24126 5.99263 5.24126 6.12986Z" fill="#FE4F28"/><path d="M6.99423 6.99733C6.86089 6.99733 6.72755 7.00033 6.59421 6.99683C6.316 6.98982 6.15709 6.87412 6.13754 6.60567C6.11398 6.28312 6.11699 5.95657 6.13855 5.63352C6.15459 5.39612 6.26587 5.28493 6.50649 5.26891C6.83332 5.24687 7.16416 5.24737 7.4915 5.26991C7.73061 5.28643 7.83989 5.39862 7.85593 5.63803C7.87748 5.95707 7.88049 6.27911 7.85793 6.59815C7.83888 6.86861 7.68249 6.98781 7.40678 6.99683C7.26943 7.00133 7.13158 6.99783 6.99423 6.99783V6.99733Z" fill="#FE4F28"/><path d="M9.6194 6.99232C9.4655 6.99232 9.30961 7.00534 9.15722 6.98932C8.90558 6.96277 8.78176 6.85509 8.76422 6.60216C8.74216 6.28362 8.74316 5.96108 8.76422 5.64204C8.78076 5.39562 8.89756 5.28043 9.1497 5.2639C9.46851 5.24286 9.79134 5.24387 10.1101 5.26691C10.3563 5.28443 10.4681 5.39763 10.4846 5.64104C10.5062 5.96008 10.5082 6.28262 10.4851 6.60116C10.4656 6.87062 10.3077 6.98882 10.0314 6.99683C9.8941 7.00084 9.75625 6.99733 9.6189 6.99733C9.6189 6.99583 9.6189 6.99433 9.6189 6.99282L9.6194 6.99232Z" fill="#FE4F28"/></svg>';

  var SVG_USP_FIRE = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none"><g clip-path="url(#clip0_17497_512)"><path d="M5.52236 0.647859C5.73564 0.448249 6.0665 0.450984 6.27979 0.650593C7.03447 1.3588 7.74268 2.12169 8.4044 2.94747C8.70518 2.55372 9.04697 2.12442 9.41611 1.77442C9.63213 1.57208 9.96572 1.57208 10.1817 1.77716C11.1278 2.6795 11.929 3.87169 12.4923 5.00372C13.0474 6.11934 13.4165 7.25958 13.4165 8.06348C13.4165 11.5525 10.6876 14.5002 7.2915 14.5002C3.85713 14.5002 1.1665 11.5498 1.1665 8.06075C1.1665 7.01075 1.65322 5.72833 2.40791 4.45958C3.1708 3.17169 4.24814 1.82911 5.52236 0.647859ZM7.33799 11.8752C8.02979 11.8752 8.64229 11.6838 9.21924 11.301C10.3704 10.4971 10.6794 8.88927 9.9876 7.62598C9.86455 7.37989 9.5501 7.36348 9.37236 7.5713L8.6833 8.37247C8.50283 8.58028 8.17744 8.57481 8.00791 8.3588C7.55674 7.78458 6.7501 6.75919 6.29072 6.17676C6.11846 5.95801 5.79033 5.95528 5.61533 6.17403C4.69111 7.33614 4.22627 8.06895 4.22627 8.892C4.229 10.765 5.6126 11.8752 7.33799 11.8752Z" fill="white"/></g><defs><clipPath id="clip0_17497_512"><rect width="14" height="14" fill="white" transform="translate(0 0.5)"/></clipPath></defs></svg>';

  var USP_ICONS = { '2P': SVG_USP_2P, 'HOTEL': SVG_USP_HOTEL, 'FIRE': SVG_USP_FIRE };

  // ── Helpers ──

  function esc(str) {
    if (!str) return '';
    var d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }

  // Mirrors the PDP's `money_without_trailing_zeros` Liquid filter: whole amounts
  // render without decimals, anything with cents always renders both digits
  // (49.9 -> "49.90"), so PLP and PDP never disagree. See GFTY-5343.
  function formatPrice(price) {
    var n = Number(price);
    if (isNaN(n)) return '0';
    var hasCents = Math.round(n * 100) % 100 !== 0;
    return n.toLocaleString('en-US', {
      minimumFractionDigits: hasCents ? 2 : 0,
      maximumFractionDigits: 2
    });
  }

  function buildResponsiveImageUrl(url, width, height) {
    if (!url || !url.includes('media')) return url || '';
    var parts = url.split('/');
    var result = [];
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      if (part.includes('x') && part !== 'x') {
        var dims = part.split('x');
        if (dims.length === 2 && !isNaN(Number(dims[0])) && !isNaN(Number(dims[1]))) {
          result.push(width + 'x' + height);
        } else {
          result.push(part);
        }
      } else {
        result.push(part);
      }
    }
    return result.join('/') + '.webp';
  }

  // ── Hotel nights (GFTY-5538) ──
  // Mirrors packages/product-tiles/src/hotelNights.js: a hotel whose variants span several
  // night counts (meta.search.duration_grouped, e.g. ["One Night", "Two Nights"]) shows
  // "1 - 2 nights"; otherwise the caller keeps dynamic_counts.SLVHotelNumberOfNightsCount.

  var NUMBER_WORDS = { one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7 };

  function nightsFromDuration(label) {
    if (typeof label !== 'string') return null;
    var match = label.trim().toLowerCase().match(/^(\d+|[a-z]+)\s+nights?$/);
    if (!match) return null;
    var n = /^\d+$/.test(match[1]) ? Number(match[1]) : NUMBER_WORDS[match[1]];
    return n > 0 ? n : null;
  }

  function hotelNightsRange(hit) {
    var search = hit && hit.meta && hit.meta.search;
    var durations = search && Array.isArray(search.duration_grouped) ? search.duration_grouped : [];
    if (!durations.length && search && Array.isArray(search.variants)) {
      durations = search.variants.map(function (v) { return v && v.duration; });
    }
    var counts = [];
    for (var i = 0; i < durations.length; i++) {
      var n = nightsFromDuration(durations[i]);
      if (n !== null && counts.indexOf(n) === -1) counts.push(n);
    }
    if (counts.length < 2) return null;
    return Math.min.apply(null, counts) + ' - ' + Math.max.apply(null, counts) + ' nights';
  }

  // ── Main renderer ──

  function renderProductCardV2(hit, index, options) {
    var hidePrice = !!(options && options.hidePrice);
    var custom = hit.meta && hit.meta.custom ? hit.meta.custom : {};
    var dynamic = custom.dynamic_counts || {};
    var productType = hit.product_type || '';

    // Location text
    var locationText = '';
    if (productType === 'MLV') {
      var locCount = dynamic.MLVLocationsCount;
      if (locCount && locCount !== '0') {
        locationText = locCount === '1' ? '1 Location' : locCount + ' Locations';
      }
    } else {
      var cl = custom.computed_location;
      if (cl && cl.short && cl.short !== 'null, null' && cl.short !== '') {
        locationText = cl.short || cl.long || '';
      }
    }

    // Pricing
    var displayPrice = hit.variants_min_price;
    var displayCompare = hit.variants_compare_at_price_min;
    var showFrom = (hit.variants_count || 0) > 1;
    var hasDiscount = displayCompare > displayPrice;
    var discountText = '';
    if (hasDiscount) {
      var savedPct = Math.round((displayCompare - displayPrice) * 100 / displayCompare);
      discountText = 'Save ' + savedPct + '%';
    }

    // Reviews
    var reviewStats = dynamic.reviewStats;
    var avgRating = reviewStats ? reviewStats.averageRating : null;
    var reviewCount = reviewStats ? reviewStats.total : null;

    // Promotion data & flash sale
    var promotionData = custom.promotion_data || [];
    var hasPromotion = promotionData.length > 0;
    // USP tag (only if no promotion)
    var topUsp = null;
    if (!hasPromotion) {
      var uspTags = custom.usp_tags || [];
      var topPriority = 999;
      for (var j = 0; j < uspTags.length; j++) {
        if (uspTags[j] == null) continue;
        var tp = uspTags[j].displayPriority != null ? uspTags[j].displayPriority : 999;
        if (tp < topPriority) { topPriority = tp; topUsp = uspTags[j]; }
      }
    }

    // Availability
    var isAvailable = !(hit.inventory_policy === 'deny' && String(hit.id) !== '8288261177643');

    // Experience type flags
    var isGiftCard = custom.experience_type === 'Gift Card';
    var isHotel = productType === 'HOTEL';
    var isMcv = productType === 'MCV';
    var isAtHome = !!custom.at_home_product;
    var isPackaged = !!custom.packaged_product;

    // Images — process array like Preact app, max 5
    var allImages = [];
    if (hit.images && hit.images.length > 0) {
      for (var ii = 0; ii < hit.images.length && allImages.length < 5; ii++) {
        if (hit.images[ii] && hit.images[ii].url) allImages.push(hit.images[ii].url);
      }
    }
    if (allImages.length === 0 && hit.product_image) {
      allImages.push(hit.product_image);
    }
    var hasMultipleImages = allImages.length > 1;
    var cardId = 'pcv2-' + (hit.id || index) + '-' + index;

    // ── Build HTML ──
    // Store hit in memory for dataLayer tracking
    storeHit(hit);

    var html = '';

    html += '<article class="product-card-v2 rounded-3xl overflow-hidden flex flex-col h-full relative' + (isAvailable ? '' : ' product-card-out-of-stock') + '" data-product-id="' + esc(String(hit.id)) + '">';

    // Gradient border wrapper
    html += '<div class="rounded-3xl p-[2px] overflow-hidden h-full bg-gray-100">';
    html += '<div class="bg-white rounded-[calc(1.5rem-2px)] shadow-lg flex flex-col h-full overflow-hidden">';

    // Unavailable overlay
    if (!isAvailable) {
      html += '<div class="absolute inset-0 bg-white/60 z-30 flex items-center justify-center rounded-3xl">';
      html += '<span class="text-sm font-semibold font-inter-tight text-giftory-midnight">Currently Unavailable</span>';
      html += '</div>';
    }

    // Link wrapper
    html += '<a href="/products/' + esc(hit.handle) + '" aria-label="' + esc(hit.title) + '" class="no-underline text-inherit hover:no-underline flex flex-col h-full">';

    // ── Image area ──
    html += '<div class="relative w-full">';

    if (allImages.length > 0) {
      if (hasMultipleImages) {
        // Multi-image carousel
        html += '<div class="pcv2-img-carousel" id="' + cardId + '-carousel">';
        html += '<div class="pcv2-img-track">';
        for (var si = 0; si < allImages.length; si++) {
          var srcUrl = allImages[si];
          var mobUrl = buildResponsiveImageUrl(srcUrl, 650, 450);
          var dskUrl = buildResponsiveImageUrl(srcUrl, 728, 534);
          if (!srcUrl.includes('media')) { mobUrl = srcUrl; dskUrl = srcUrl; }
          var sLoading = (index < 4 && si === 0) ? 'eager' : 'lazy';
          var sFetch = (index < 4 && si === 0) ? ' fetchpriority="high"' : '';
          html += '<div class="pcv2-img-slide">';
          html += '<picture>';
          html += '<source media="(max-width: 767px)" srcset="' + esc(mobUrl) + '" width="650" height="450">';
          html += '<source media="(min-width: 768px)" srcset="' + esc(dskUrl) + '" width="728" height="534">';
          html += '<img src="' + esc(dskUrl) + '" alt="' + esc(hit.title) + ' - Image ' + (si + 1) + '" width="728" height="534" loading="' + sLoading + '"' + sFetch + ' class="w-full h-full object-cover">';
          html += '</picture>';
          html += '</div>';
        }
        html += '</div>';
        // Dots
        html += '<div class="pcv2-img-dots">';
        html += '<div class="pcv2-img-dots-inner">';
        for (var di = 0; di < allImages.length; di++) {
          html += '<span class="pcv2-img-dot' + (di === 0 ? ' active' : '') + '"></span>';
        }
        html += '</div></div>';
        // Nav arrows (desktop hover) — matching pods-carousel-v3 style
        html += '<button class="pcv2-img-nav pcv2-img-prev" aria-label="Previous image">';
        html += '<svg class="pcv2-img-nav-icon pcv2-img-nav-flip" width="8" height="14" fill="none" aria-hidden="true" focusable="false"><use href="#gf-core-chevron-8x14"></use></svg>';
        html += '</button>';
        html += '<button class="pcv2-img-nav pcv2-img-next" aria-label="Next image">';
        html += '<svg class="pcv2-img-nav-icon" width="8" height="14" fill="none" aria-hidden="true" focusable="false"><use href="#gf-core-chevron-8x14"></use></svg>';
        html += '</button>';
        html += '</div>';
      } else {
        // Single image
        var imageUrl = allImages[0];
        var mobileUrl = buildResponsiveImageUrl(imageUrl, 650, 450);
        var desktopUrl = buildResponsiveImageUrl(imageUrl, 728, 534);
        if (!imageUrl.includes('media')) { mobileUrl = imageUrl; desktopUrl = imageUrl; }
        var imgLoading = index < 4 ? 'eager' : 'lazy';
        var fetchPriority = index < 4 ? ' fetchpriority="high"' : '';
        html += '<picture>';
        html += '<source media="(max-width: 767px)" srcset="' + esc(mobileUrl) + '" width="650" height="450">';
        html += '<source media="(min-width: 768px)" srcset="' + esc(desktopUrl) + '" width="728" height="534">';
        html += '<img src="' + esc(desktopUrl) + '" alt="' + esc(hit.title) + '" width="728" height="534" loading="' + imgLoading + '"' + fetchPriority + ' class="w-full object-cover aspect-[728/534]">';
        html += '</picture>';
      }
    }

    // Badge overlay
    html += '<div class="absolute top-3 left-3 z-20">';
    if (topUsp) {
      var tplName = topUsp.templateName || 'DEFAULT';
      var uspIcon = USP_ICONS[tplName] || '';
      html += '<div class="tag-container_' + esc(tplName) + ' shadow-[0px_4px_24px_0px_rgba(0,0,0,0.06)]">';
      html += '<div class="tag-frame">';
      if (uspIcon) html += uspIcon;
      html += '<div class="tag-title">' + esc(topUsp.tagName) + '</div>';
      html += '</div></div>';
    }
    html += '</div>'; // end badge overlay
    html += '</div>'; // end image area

    // ── Card body ──
    html += '<div class="p-4 md:!p-5 flex flex-col gap-4 md:!gap-5 flex-1">';
    html += '<header class="flex flex-col gap-3 flex-1">';

    // Title
    html += '<h3 class="text-giftory-midnight text-base md:text-lg font-bold font-inter-tight !leading-[1.375rem] md:!leading-[1.5rem] line-clamp-2">' + esc(hit.title) + '</h3>';

    // Location + Reviews row
    html += '<div class="inline-flex items-center gap-3 w-full">';
    if (locationText) {
      html += '<address class="flex items-center gap-2 md:gap-2.5 max-w-[66%] not-italic">';
      html += '<div class="w-4 h-4 md:!w-5 md:!h-5 flex-shrink-0">' + SVG_LOCATION_PIN(hit.id) + '</div>';
      html += '<span class="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight leading-[16px] md:leading-[18px] truncate">' + esc(locationText) + '</span>';
      html += '</address>';
    }
    if (avgRating && reviewCount && reviewCount !== 0) {
      html += '<div class="flex items-center gap-1.5 w-auto flex-shrink-0">';
      html += SVG_STAR;
      html += '<span class="text-neutral-100 text-xs md:text-sm font-semibold font-inter-tight leading-[18px]">' + avgRating + '</span>';
      html += '<span class="text-neutral-100 text-xs md:text-sm font-normal font-inter-tight leading-[18px]">(' + reviewCount + ')</span>';
      html += '</div>';
    }
    html += '</div>';

    // ── Attributes ──
    var nop = dynamic.numberOfPeople;

    // People count (not for gift card or hotel)
    if (!isGiftCard && !isHotel && nop && nop !== '*') {
      html += '<div class="flex items-start gap-2 md:gap-2.5">';
      html += '<div class="w-4 h-4 md:!w-5 md:!h-5 flex-shrink-0 flex items-center justify-center" aria-hidden="true">';
      html += (nop === '1') ? SVG_PERSON_SINGLE : SVG_PERSON_MULTI;
      html += '</div>';
      html += '<span class="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight leading-[16px] md:leading-[18px] capitalize">' + esc(nop) + ' ' + (nop === '1' ? 'Person' : 'People') + '</span>';
      html += '</div>';
    }

    // Packaged options (non-MCV)
    if (!isMcv && isPackaged) {
      var optsCount = dynamic.packagedProductOptionsCount;
      if (optsCount && optsCount !== '0' && optsCount !== 'null') {
        html += '<div class="flex items-start gap-2 md:gap-2.5">';
        html += '<div class="w-4 h-4 md:!w-5 md:!h-5 flex-shrink-0 flex items-center justify-center" aria-hidden="true">' + SVG_LAYERS + '</div>';
        var optsText = String(optsCount).toLowerCase().includes('option') ? optsCount : optsCount + (optsCount === '1' ? ' Option' : ' Options');
        html += '<span class="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight leading-[16px] md:leading-[18px] capitalize">' + esc(optsText) + '</span>';
        html += '</div>';
      }
    }

    // MCV options
    if (isMcv) {
      var mcvCount = dynamic.MCVProductsCount;
      if (mcvCount && mcvCount !== '0' && mcvCount !== 'null') {
        html += '<div class="flex items-start gap-2 md:gap-2.5">';
        html += '<div class="w-4 h-4 md:!w-5 md:!h-5 flex-shrink-0 flex items-center justify-center" aria-hidden="true">' + SVG_LAYERS + '</div>';
        var mcvText = String(mcvCount).toLowerCase().includes('option') ? mcvCount : mcvCount + ' Options';
        html += '<span class="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight leading-[16px] md:leading-[18px] capitalize">' + esc(mcvText) + '</span>';
        html += '</div>';
      }
    }

    // Hotel: nights + hotel count
    if (isHotel) {
      var nights = hotelNightsRange(hit) || dynamic.SLVHotelNumberOfNightsCount;
      if (nights) {
        html += '<div class="flex items-start gap-2 md:gap-2.5">';
        html += '<div class="w-4 h-4 md:!w-5 md:!h-5 flex-shrink-0 flex items-center justify-center" aria-hidden="true">' + SVG_BED + '</div>';
        html += '<span class="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight leading-[16px] md:leading-[18px] capitalize">' + esc(nights) + '</span>';
        html += '</div>';
      }
      var hotelCount = dynamic.SLVHotelCount;
      if (hotelCount && hotelCount !== '0') {
        html += '<div class="flex items-start gap-2 md:gap-2.5">';
        html += '<div class="w-4 h-4 md:!w-5 md:!h-5 flex-shrink-0 flex items-center justify-center" aria-hidden="true">' + SVG_BUILDING + '</div>';
        html += '<span class="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight leading-[16px] md:leading-[18px] capitalize">' + esc(hotelCount) + '</span>';
        html += '</div>';
      }
    }

    // At Home
    if (isAtHome) {
      html += '<div class="flex items-start gap-2 md:gap-2.5">';
      html += '<div class="w-4 h-4 md:!w-5 md:!h-5 flex-shrink-0 flex items-center justify-center" aria-hidden="true">' + SVG_HOME + '</div>';
      html += '<span class="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight leading-[16px] md:leading-[18px] capitalize">At Your Home</span>';
      html += '</div>';
    }

    html += '</header>'; // end header

    if (!hidePrice) {
      // Divider
      html += '<span class="w-full border-t border-gray-200 block"></span>';

      // ── Pricing footer ──
      html += '<footer class="flex justify-between items-center">';
      html += '<div>';
      if (showFrom) {
        html += '<span class="text-giftory-midnight text-xs md:text-sm font-medium font-inter-tight leading-[22px] md:leading-normal">From </span>';
      }
      html += '<span class="text-giftory-midnight text-lg md:text-xl font-extrabold font-inter-tight leading-[22px] md:leading-normal">$' + formatPrice(displayPrice) + '</span>';
      if (hasDiscount) {
        html += '<span class="text-neutral-100 text-xs md:text-sm font-medium font-inter-tight line-through leading-[22px] md:leading-normal pl-1 italic">$' + formatPrice(displayCompare) + '</span>';
      }
      html += '</div>';

      if (hasDiscount) {
        html += '<div class="flex items-start">';
        html += '<div class="px-2 py-1.5 bg-[#E30016] rounded-lg flex justify-center items-center gap-1">';
        html += '<span class="text-center text-white text-xs font-medium font-inter-tight uppercase leading-none">' + discountText + '</span>';
        html += '</div></div>';
      }

      html += '</footer>';
    }
    html += '</div>'; // end card body
    html += '</a>';
    html += '</div>'; // end inner white card
    html += '</div>'; // end gradient border
    html += '</article>';

    return html;
  }

  /**
   * Initialize flash sale countdowns on all hosts within a container.
   * Call after injecting cards into DOM.
   */
  function initFlashSaleCountdowns(container) {
    if (!window.renderFlashSaleCountdown) return;
    var hosts = container.querySelectorAll('.flash-sale-countdown-host');
    hosts.forEach(function (host) {
      if (host.__flashSaleInitialized) return;
      var promoAttr = host.getAttribute('data-promotion-data');
      var sizeAttr = host.getAttribute('data-size') || 'small';
      var showTimerAttr = host.getAttribute('data-show-timer');
      var config = {
        size: sizeAttr,
        showTimer: showTimerAttr !== 'false'
      };
      if (promoAttr) {
        try { config.promotionData = JSON.parse(promoAttr); } catch (e) { /* ignore */ }
      }
      window.renderFlashSaleCountdown(host, config);
    });
  }

  // ── Image carousel CSS (injected once) ──
  var carouselCSSInjected = false;
  function injectCarouselCSS() {
    if (carouselCSSInjected) return;
    carouselCSSInjected = true;
    var style = document.createElement('style');
    style.textContent = [
      '/* Card entry animation */',
      '.cec-v2-card-wrap { opacity: 0; animation: pcv2-card-enter 0.5s ease forwards; }',
      '@keyframes pcv2-card-enter { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: none; } }',
      '/* Card wrapper — keeps border-radius on hover */',
      '.cec-v2-card-wrap { border-radius: 24px; overflow: hidden; isolation: isolate; background: #fff; transition: transform 0.5s cubic-bezier(0.22,1,0.36,1), box-shadow 0.5s cubic-bezier(0.22,1,0.36,1); box-shadow: 0 4px 20px rgba(0,0,0,0.08); }',
      '@media (min-width: 750px) { .cec-v2-card-wrap:hover { transform: translateY(-8px); box-shadow: 0 8px 30px rgba(0,0,0,0.15); } }',
      '.product-card-v2 { }',
      '/* Image zoom on card hover — desktop only */',
      '.pcv2-img-slide img, .product-card-v2 picture img { transition: transform 0.6s cubic-bezier(0.22,1,0.36,1); }',
      '@media (min-width: 750px) { .cec-v2-card-wrap:hover .pcv2-img-slide img, .cec-v2-card-wrap:hover picture img { transform: scale(1.05); } }',
      '/* CTA card hover — desktop only */',
      '.cec-v2-cta-card { transition: transform 0.5s cubic-bezier(0.22,1,0.36,1), box-shadow 0.5s cubic-bezier(0.22,1,0.36,1); }',
      '@media (min-width: 750px) { .cec-v2-cta-card:hover { transform: translateY(-8px); box-shadow: 0 8px 30px rgba(0,0,0,0.15); } }',
      '.pcv2-img-carousel { position: relative; width: 100%; aspect-ratio: 728/534; overflow: hidden; }',
      '.pcv2-img-slide { overflow: hidden; }',
      '.pcv2-img-track { display: flex; overflow-x: auto; scroll-snap-type: x mandatory; scrollbar-width: none; -webkit-overflow-scrolling: touch; width: 100%; height: 100%; }',
      '.pcv2-img-track::-webkit-scrollbar { display: none; }',
      '.pcv2-img-slide { flex: 0 0 100%; width: 100%; height: 100%; scroll-snap-align: start; }',
      '.pcv2-img-slide picture, .pcv2-img-slide img { width: 100%; height: 100%; object-fit: cover; display: block; }',
      '.pcv2-img-dots { position: absolute; bottom: 10px; left: 50%; transform: translateX(-50%); z-index: 10; pointer-events: none; }',
      '.pcv2-img-dots-inner { display: flex; align-items: center; gap: 4px; padding: 4px; background: rgba(0,0,0,0.48); border-radius: 40px; }',
      '.pcv2-img-dot { width: 6px; height: 6px; border-radius: 50%; background: rgba(255,255,255,0.5); transition: all 0.3s ease; box-shadow: 0 1px 3px rgba(0,0,0,0.15); flex-shrink: 0; }',
      '.pcv2-img-dot.active { width: 16px; border-radius: 800px; background: rgba(255,255,255,0.96); }',
      '.pcv2-img-nav { position: absolute; top: 50%; transform: translateY(-50%); z-index: 10; width: 40px; height: 40px; border-radius: 9999px; background: rgba(255,255,255,0.8); border: none; cursor: pointer; display: none; align-items: center; justify-content: center; box-shadow: 0 4px 24px rgba(0,0,0,0.06); padding: 13px; box-sizing: border-box; }',
      '.pcv2-img-nav-icon { color: #16102C; }',
      '.pcv2-img-nav-flip { transform: rotate(180deg); }',
      '.pcv2-img-prev { left: 8px; }',
      '.pcv2-img-next { right: 8px; }',
      '.pcv2-img-carousel:hover .pcv2-img-nav { display: flex; }',
      '@media (max-width: 749px) { .pcv2-img-nav { display: none !important; } .pcv2-img-track { overflow: hidden; scroll-snap-type: none; } .pcv2-img-dots { display: none; } }'
    ].join('\n');
    document.head.appendChild(style);
  }

  /**
   * Initialize image carousels on all cards within a container.
   * Uses native scroll-snap with IntersectionObserver for dot updates.
   */
  function initImageCarousels(container) {
    injectCarouselCSS();
    var carousels = container.querySelectorAll('.pcv2-img-carousel');
    carousels.forEach(function (carousel) {
      if (carousel.__carouselInit) return;
      carousel.__carouselInit = true;

      var track = carousel.querySelector('.pcv2-img-track');
      var dots = carousel.querySelectorAll('.pcv2-img-dot');
      var prevBtn = carousel.querySelector('.pcv2-img-prev');
      var nextBtn = carousel.querySelector('.pcv2-img-next');
      var slides = carousel.querySelectorAll('.pcv2-img-slide');
      if (!track || slides.length < 2) return;

      var currentIndex = 0;

      function updateDots(idx) {
        dots.forEach(function (d, i) {
          d.classList.toggle('active', i === idx);
        });
        currentIndex = idx;
      }

      // Scroll-based dot update (instant via rAF)
      var rafPending = false;
      track.addEventListener('scroll', function () {
        if (rafPending) return;
        rafPending = true;
        requestAnimationFrame(function () {
          rafPending = false;
          var scrollLeft = track.scrollLeft;
          var slideWidth = track.offsetWidth;
          var idx = Math.round(scrollLeft / slideWidth);
          if (idx >= 0 && idx < slides.length && idx !== currentIndex) {
            updateDots(idx);
          }
        });
      }, { passive: true });

      // Nav arrow clicks (loop)
      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var newIdx = currentIndex - 1;
          if (newIdx < 0) newIdx = slides.length - 1;
          track.scrollTo({ left: newIdx * track.offsetWidth, behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var newIdx = currentIndex + 1;
          if (newIdx >= slides.length) newIdx = 0;
          track.scrollTo({ left: newIdx * track.offsetWidth, behavior: 'smooth' });
        });
      }

      // Prevent link navigation when swiping
      var startX = 0;
      var isDragging = false;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        isDragging = false;
      }, { passive: true });
      track.addEventListener('touchmove', function () {
        isDragging = true;
      }, { passive: true });
      track.addEventListener('click', function (e) {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    });
  }

  /**
   * In-memory hit store for dataLayer tracking — keeps DOM clean.
   */
  var hitStore = {};

  /**
   * Store a hit for later dataLayer use.
   * Normalizes price to cents (Shopify format) since convertNumberToCurrency expects cents.
   */
  function storeHit(hit) {
    if (!hit || !hit.id) return;
    var stored = {
      id: hit.id,
      title: hit.title,
      product_type: hit.product_type,
      price: Math.round((hit.price || 0) * 100),
      compare_at_price: hit.compare_at_price ? Math.round(hit.compare_at_price * 100) : null,
      meta: hit.meta
    };
    hitStore[String(hit.id)] = stored;
  }

  /**
   * Initialize dataLayer select_item tracking on card clicks.
   *
   * `listName` is optional and names the *component* the card was clicked in
   * (e.g. 'recently_viewed'). Without it the list name falls back to the page
   * slug, which cannot distinguish two card carousels on the same page — pass
   * it whenever you need per-component attribution. Existing callers that omit
   * it keep the original page-slug behaviour.
   */
  function initCardDataLayer(container, listName) {
    if (typeof pushDataLayerSelectItem !== 'function') return;
    var cards = container.querySelectorAll('.product-card-v2[data-product-id]');
    cards.forEach(function (card) {
      if (card.__dlInit) return;
      card.__dlInit = true;
      card.addEventListener('click', function () {
        var id = card.getAttribute('data-product-id');
        var hit = hitStore[id];
        if (!hit) return;
        var name = listName || window.location.pathname.split('/').pop().split('?')[0] || 'homepage';
        pushDataLayerSelectItem('select_item', name, name, hit);
      });
    });
  }

  // Expose globally
  if (typeof window !== 'undefined') {
    window.renderProductCardV2 = renderProductCardV2;
    window.initFlashSaleCountdowns = initFlashSaleCountdowns;
    window.initImageCarousels = initImageCarousels;
    window.initCardDataLayer = initCardDataLayer;
  }
  // For unit tests (tests/hotel-nights.test.js)
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { nightsFromDuration: nightsFromDuration, hotelNightsRange: hotelNightsRange };
  }
})();
